import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useT } from '../i18n/LanguageContext';
import Icon from '../components/Icon';

const Login: React.FC = () => {
  const t = useT();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const STATS: [string, string][] = [
    ['96%', t('stopa isporuke', 'delivery rate')],
    ['2.4M', t('poruka / mesec', 'messages / month')],
    ['3', t('kanala', 'channels')],
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.error || t('Greška prilikom prijavljivanja', 'Login error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-split">
      {/* left brand panel */}
      <div className="login-brand">
        <div className="login-blob" style={{ width: 420, height: 420, top: -120, right: -120 }} />
        <div className="login-blob" style={{ width: 280, height: 280, bottom: -80, left: -60, opacity: 0.6 }} />

        <div className="brand" style={{ position: 'relative' }}>
          <span className="brand-mark" style={{ background: 'rgba(255,255,255,.16)', boxShadow: 'none' }}>
            <Icon name="send" size={18} />
          </span>
          <span className="brand-name" style={{ color: '#fff' }}>
            Vemid <b style={{ color: '#fff', opacity: 0.85 }}>Sendly</b>
          </span>
        </div>

        <div style={{ position: 'relative' }}>
          <h1 style={{ fontSize: 36, lineHeight: 1.12, fontWeight: 800, maxWidth: 440 }}>
            {t('Jedna platforma za Email, SMS i Viber.', 'One platform for Email, SMS and Viber.')}
          </h1>
          <p style={{ marginTop: 18, fontSize: 16, opacity: 0.9, maxWidth: 420, lineHeight: 1.6 }}>
            {t(
              'Kreirajte liste, gradite kampanje i pratite rezultate uživo — sve na jednom mestu.',
              'Create lists, build campaigns and track results live — all in one place.'
            )}
          </p>
          <div style={{ display: 'flex', gap: 26, marginTop: 40 }}>
            {STATS.map(([v, label]) => (
              <div key={label}>
                <div className="tnum" style={{ fontSize: 26, fontWeight: 800 }}>{v}</div>
                <div style={{ fontSize: 13, opacity: 0.8 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ position: 'relative', fontSize: 13, opacity: 0.7 }}>
          © {new Date().getFullYear()} Vemid · {t('razvio', 'developed by')}{' '}
          <a href="https://www.vemid.net" style={{ color: '#fff', fontWeight: 700 }}>Vemid SOFT</a>
        </div>
      </div>

      {/* right form */}
      <div className="login-form-side">
        <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 380 }}>
          <h2 style={{ fontSize: 26, fontWeight: 800 }}>{t('Dobrodošli nazad', 'Welcome back')}</h2>
          <p className="muted" style={{ marginTop: 6 }}>{t('Prijavite se da nastavite na svoj nalog.', 'Sign in to continue to your account.')}</p>

          {error && (
            <div className="card card-pad" style={{ borderColor: 'var(--danger)', color: 'var(--danger-strong)', margin: '20px 0 0' }}>
              <Icon name="alert" size={16} /> {error}
            </div>
          )}

          <div style={{ marginTop: 26 }}>
            <div className="field">
              <label className="label">{t('Korisničko ime', 'Username')}</label>
              <div className="input-icon">
                <Icon name="mail" size={16} />
                <input
                  className="input"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder={t('Unesite korisničko ime', 'Enter your username')}
                  required
                  autoFocus
                />
              </div>
            </div>

            <div className="field">
              <label className="label">{t('Lozinka', 'Password')}</label>
              <div className="input-icon">
                <Icon name="shield" size={16} />
                <input
                  className="input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t('Unesite lozinku', 'Enter your password')}
                  required
                />
              </div>
            </div>

            <div className="flex items-center justify-between" style={{ margin: '6px 0 22px' }}>
              <label className="flex items-center gap-8" style={{ fontSize: 13.5, fontWeight: 600, cursor: 'pointer' }}>
                <input type="checkbox" className="row-check" defaultChecked /> {t('Zapamti me', 'Remember me')}
              </label>
              <span className="dim" style={{ fontSize: 13.5, fontWeight: 600 }}>{t('Zaboravljena lozinka?', 'Forgot password?')}</span>
            </div>

            <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={loading}>
              {loading ? t('Prijavljivanje…', 'Signing in…') : <>{t('Prijavi se', 'Sign in')} <Icon name="arrowRight" size={17} /></>}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
